module.exports = __webpack_public_path__ + "img/CS-UL-I-Info.2d5d7720.jpg";